import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { SsFamilleService } from './../../../services/simple/ss-famille.service';
import { SsDomaineService } from './../../../services/simple/ss-domaine.service';
import { SsDomaineModel } from './../../../models/simple-types/ss-domaine.model';
import { SsFamilleModel } from './../../../models/simple-types/ss-famille.model';
import { NaModel } from '../../../models/simple-types/na.model';
import { CategorieModel } from '../../../models/simple-types/categorie.model';
import { CgChargeModel } from '../../../models/simple-types/cg-charge.model';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { TvaModel } from './../../../models/simple-types/tva.model';
import { ArticleService } from './../../../services/societe-linked/article.service';
import { ArticleModel } from 'src/app/shared/models/societe-linked/article.model';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GestionCa1Component } from './../../../../core/gestion-referentiel/gestion-ca1/gestion-ca1.component';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';
import { DetailReferentielInfos } from 'src/app/core/gestion-referentiel/gestion-referentiel-component.service';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';

export interface DialogData {
  form: UntypedFormGroup;
  referentiel: DetailReferentielInfos;
  famille: SsFamilleModel;
  domaine: SsDomaineModel;
  societeId: number;
  result: boolean;
}
@Component({
  selector: 'app-modal-add-article',
  templateUrl: './modal-add-article.component.html',
  styleUrls: ['./modal-add-article.component.scss']
})
export class ModalAddArticleComponent implements OnInit {

  articles: ArticleModel[];
  form: UntypedFormGroup;
  na: NaModel;
  tva: TvaModel;
  site: SiteModel;
  cgCharge: CgChargeModel;
  categorie: CategorieModel;
  sites: SiteModel[];
  familles: SsFamilleModel[];
  famille: SsFamilleModel = null;
  domaines: SsDomaineModel[];
  domaine: SsDomaineModel = null;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionCa1Component>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private siteService: SiteService
            , private articleService: ArticleService
            , private ssDomaineService: SsDomaineService
            , private ssFamilleService: SsFamilleService ) {

             }

    ngOnInit(): void {
      this.articles = this.data.referentiel.articles;
      // Ajouter un SeuilModel + gestion des seuils
      this.form = this.data.form;
      this.ssFamilleService.getAll().subscribe(familles => {
        this.familles = familles;
      });
      this.ssDomaineService.getAll().subscribe(domaines => {
        this.domaines = domaines;
      });
      if (this.form.get('id').value && this.form.get('code').value) {
        this.na = this.data.referentiel.nas.find(s => s.code === this.data.form.get('codeNa').value);
        this.tva = this.data.referentiel.tvas.find(s => s.code === this.data.form.get('codeTva').value);
        this.cgCharge = this.data.referentiel.cgCharges.find(s => s.code === this.data.form.get('codeCg').value);
        this.categorie = this.data.referentiel.categories.find(s => s.code === this.data.form.get('codeCategorie').value);
        this.famille = this.data.famille;
        this.domaine = this.data.domaine;
         
      }

      // Récuperation des sites
      this.siteService.getFromSociete(this.data.societeId).subscribe(sites => {
        this.sites = sites;
        this.site = sites.find(s => s.code === this.data.form.get('codeSite').value);
      });
    }

    onChangeFamille(famille: SsFamilleModel): void{
      this.form.get('idSsFamille').setValue(famille.id);
    }

    onChangeDomaine(famille: SsDomaineModel): void{
      this.form.get('idSsDomaine').setValue(famille.id);
    }

    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const article = this.form.getRawValue();
        this.site ? article.codeSite = this.site.code : article.codeSite = '';
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.articleService.save(article).subscribe((a: ArticleModel) => {
              if (a) {
                this.toastr.success('', 'Création de l\'article ' + a.code + ' réussie');
              }
              this.dialogRef.close(true);
              dialogRef.close();
            }, (error) => {
              this.dialogRef.close(true);
              dialogRef.close();
            });
        }else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.articleService.update(article.id, article).subscribe((a: ArticleModel) => {
            this.toastr.success('', 'Modification de l\'article ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
              this.dialogRef.close(true);
              dialogRef.close();
            });
        }
      } else {
        this.displayErrors();
      }
   }

   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

